import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MapServiceService } from '../../services/Map-service/map-service.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-gps-error-modal',
  templateUrl: './gps-error-modal.component.html',
  styleUrls: ['./gps-error-modal.component.css'],
})
export class GpsErrorModalComponent implements OnInit {
  title: any;
  message: any;
  isDesktop = false
  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    public mapService: MapServiceService,
    private deviceService: DeviceDetectorService
  ) {
    //
    this.isDesktop = this.deviceService.isDesktop();
  }

  ngOnInit(): void {

    console.log( )
    this.title = this.data.title;
    this.message = this.mapService.getAllModals.gps_error
  }

  colseModal(): void {
    this.dialog.closeAll();
  }
}
